import { render, staticRenderFns } from "./CircleRecordIcon.vue?vue&type=template&id=2680cff8&"
import script from "./CircleRecordIcon.vue?vue&type=script&lang=js&"
export * from "./CircleRecordIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports